// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__ZwgYC","plus":"styles_plus__PzXqr","key":"styles_key__j7b3S"};